import request from '@/utils/http'

const BASE_URL = "https://204910013.xyz/";
// const BASE_URL = "http://localhost:8080/";

// 文章浏览量+1
export const addViewCount = (articleId) => {
    // return request.requestPost(BASE_URL+"portal/article/view/"+articleId)
    // console.log(BASE_URL+"portal/article/view?articleId="+articleId)
    return request.requestPost(BASE_URL+"portal/article/view?articleId="+articleId)
};
